// @ts-nocheck
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react';
import {
  Linking,
  InteractionManager,
  useWindowDimensions,
  View,
  StyleSheet,
  Image,
  ScrollView,
} from 'react-native';
import {TouchableOpacity} from 'react-native-gesture-handler';
import {Card, Divider} from 'react-native-paper';
import Ionicons from '@expo/vector-icons/Ionicons';
import {fetchAlertDetail, fetchNotificationById} from '../../../api/alert';
import LoadingSpinner from '../../../components/LoadingSpinner';
import Navbar from '../../../components/Navbar';
import {showErrorMessage, showSuccessMessage} from '../../../service/flashMessage';
import {styles as globalStyles} from '../../../styles';
import {getNotificationAction} from '../../../utils';
import {useDispatch, useSelector} from 'react-redux';
import {HandleAlertButton, ReadAlert} from '../alertsReducer';
import useColorMode from '../../../components/useColorMode';
import {Alert} from '../../../@types';
import {RootStore} from '../../../redux/store';
import WebView from 'react-native-webview';
import Text from '../../../components/Text';
import {EventNames} from '../../../@types/EventNames';
import {VISITOR_SCREEN_TIMEOUT_DURATION} from '../../../constants';
import isWeb from '../../../utils/isWeb';
import Container from '../../../components/Container';
import ResponseBadge from '../components/ReponseBadge';
import { useFocusEffect } from '@react-navigation/native';

const NotificationDetails = ({navigation, route}) => {
  const {colorMode} = useColorMode();
  const color = colorMode === 'light' ? '#fff' : '#000';
  const {alertId, id, isFromTray} = route.params;
  const [isLoading, setIsloading] = useState(true);
  const [notification, setNotification] = useState<Alert>({} as Alert);
  const [isRepliedTo, setIsRepliedTo] = useState(true);
  const dispatch = useDispatch();
  const [buttonsShown, setButtonsShown] = useState(true);
  const [alertTimedOut, setAlertTimedOut] = useState(false);
  const [htmlReady, setHtmlReady] = useState(false);
  const [responding, setResponding] = useState(false);

  const {isReading} = useSelector((state: RootStore) => state.alerts);
  const {height, width} = useWindowDimensions();

  useFocusEffect(
    useCallback(() => {
      let cancelled = false;
      const task = InteractionManager.runAfterInteractions(() => {
        if (!cancelled) {
          fetchNotification(alertId, id);
        }
      });

      return () => {
        cancelled = true;
        if (task && typeof task.cancel === 'function') {
          task.cancel();
        }
      };
    }, [alertId, id, isFromTray, height, width]),
  );

  useEffect(()=>{
    if(isWeb  && !!notification.appMessageHTML){
     setTimeout(()=>{
        const templateContainer = document.getElementById('tableContainer');
        console.log("templateContainer", templateContainer);
        if(templateContainer){
          templateContainer.style.transition = 'width 1s';
            templateContainer.style.width = '100%';
          }
      }, 1000)
    }

  },[isWeb, notification.appMessageHTML, id])

  useEffect(() => {
    setHtmlReady(false);

    if (!notification?.appMessageHTML) {
      return;
    }

    const fallbackTimer = setTimeout(() => {
      setHtmlReady(true);
    }, 1500);

    const task = InteractionManager.runAfterInteractions(() => {
      setHtmlReady(true);
    });

    return () => {
      clearTimeout(fallbackTimer);
      if (task && typeof task.cancel === 'function') {
        task.cancel();
      }
    };
  }, [notification?.appMessageHTML]);

  const fetchNotification = async (_alertId: string, _id: string) => {
    setIsloading(true);
    try {
      let res: Alert = null;

      if(isFromTray){
         res = await fetchNotificationById(
          _alertId,
          Math.round(width / 4),
          Math.round(height / 4),
        );
      }
      else{
        res = await fetchAlertDetail(
          _id,
          Math.round(width / 4),
          Math.round(height / 4),
        ); 
      }

      if (!res.read) {
        dispatch(ReadAlert(res.id));
      }

      const _isRepliedTo =
        res.eventName === 'PeopleLink' ||
        res.eventName === 'RequestAccess' ||
        res.action !== null;

      setIsRepliedTo(_isRepliedTo);

      /**
       * When should buttons be hidden
       * 1. If are visitorScreening and
       * 2. They don't have an action and
       * 3. Were received in the last 15 minutes
       */
      const isVisitorScreen = res.eventName === EventNames.VISITOR_SCREEN;
      const repliedTo = !!res.action;
      const receivedInLast15Mins =
        new Date().getTime() - new Date(res.time).getTime() >
        VISITOR_SCREEN_TIMEOUT_DURATION;

      if (isVisitorScreen) {
        if (receivedInLast15Mins && !repliedTo) {
          setAlertTimedOut(true);
          setButtonsShown(false);
        } else {
          setAlertTimedOut(false);
          setButtonsShown(true);
        }
      }

      let appMessageHTMLWithImage = res.appMessageHTML ?? '';
      if (typeof res.appMessageHTML === 'string' && res.sender?.image) {
        appMessageHTMLWithImage = res.appMessageHTML.replace(
          'cid:PictureOut',
          `data:image/jpeg;base64,${res.sender.image}`,
        );
      }

      setNotification({...res, appMessageHTML: appMessageHTMLWithImage});
      setHtmlReady(false);
      setIsloading(false);
    } catch (error) {
      showErrorMessage('AlertDetail: ' + error.message);
      setIsloading(false);
    }
  };

  const action = getNotificationAction(notification?.action);

  const imageUrl = notification?.sender?.image
    ? `data:image/jpeg;base64,${notification?.sender?.image}`
    : 'https://dummyimage.com/110x88/cccccc/cccccc.png';

  const renderHtmlContent = () => {
    if (!htmlReady) {
      return <LoadingSpinner />;
    }
    if (isWeb) {
      return (
        <div style={{ marginTop: 56 }}>
          <div
            id="html-container"
            dangerouslySetInnerHTML={{
              __html: notification?.appMessageHTML,
            }}
          />
        </div>
      );
    }
    return (
      <WebView
        source={{ html: notification.appMessageHTML }}
        renderLoading={() => <LoadingSpinner />}
        style={{ paddingBottom: 150 }}
      />
    );
  };

  const Main = () => {
    return (
      <Card style={styles.card}>
        <Image source={{uri: imageUrl}} style={styles.detailsImage} />
        <View style={styles.row}>
          <Text style={styles.textLabel}>Person name </Text>
          <Text style={styles.detailsText}>{notification?.sender?.name}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.textLabel}>Event name </Text>
          <Text style={styles.detailsText}>{notification?.eventName}</Text>
        </View>
        <Divider />
        <View style={styles.row}>
          <Text style={styles.textLabel}>Status</Text>
          <Text style={styles.detailsText}>{notification?.status}</Text>
        </View>
        <Divider />
        {action && (
          <View style={styles.row}>
            <Text
              style={[
                action.startsWith('N')
                  ? styles.alertResponseDanger
                  : styles.alertResponseSuccess,
                styles.mr0,
              ]}>
              {action}
            </Text>
          </View>
        )}
        <Divider />
        <View style={styles.row}>
          <Text style={styles.textLabel}>Message</Text>
          <Text style={styles.textLabel}>{notification.message}</Text>
        </View>
        <Divider />
        <View style={styles.row}>
          <Text style={styles.textLabel}>Phone number</Text>
          <Text style={styles.detailsText}>
            {notification.phoneNumber
              ? notification.phoneNumber
              : 'Not provided'}
          </Text>
        </View>
        <Divider />
        <View style={styles.row}>
          <Text style={styles.textLabel}>Time</Text>
          <Text style={styles.detailsText}>
            {new Date(notification.time).toLocaleString()}
          </Text>
        </View>
      </Card>
    );
  };

  const Buttons = () => {
    return (
      <>
        {(notification.button1 ||
          notification.button2 ||
          notification.button3) && (
          <Card style={styles.card}>
            <View style={styles.row}>
              {notification.button1 && buttonsShown && !responding && (
                <TouchableOpacity
                  disabled={responding}
                  onPress={async () => {
                    const response = parseInt(notification.button1.value, 10);
                    setResponding(true);
                    try {
                      await dispatch(
                        HandleAlertButton(
                          notification,
                          notification.button1.text,
                          response,
                        ),
                      );
                      setNotification(prev => ({
                        ...prev,
                        action: response,
                      }));
                      setIsRepliedTo(true);
                      setButtonsShown(false);
                      showSuccessMessage('Your response has been sent');
                    } catch (error) {
                      const message =
                        error?.response?.data?.errors?.[0] ??
                        error?.message ??
                        'Unable to update approval';
                      showErrorMessage('AlertDetail - 2: ' + message);
                    } finally {
                      setResponding(false);
                    }
                  }}
                  style={[styles.button, styles.greenButton]}>
                  <Ionicons
                    name="checkmark-circle-outline"
                    size={16}
                    color={color}
                    style={styles.icon}
                  />
                  <Text style={styles.buttonText}>
                    {notification.button1.text}
                  </Text>
                </TouchableOpacity>
              )}
              {notification.button2 && buttonsShown && !responding && (
                <TouchableOpacity
                  disabled={responding}
                  onPress={async () => {
                    const response = parseInt(notification.button2.value, 10);
                    setResponding(true);
                    try {
                      await dispatch(
                        HandleAlertButton(
                          notification,
                          notification.button2.text,
                          response,
                        ),
                      );
                      setNotification(prev => ({
                        ...prev,
                        action: response,
                      }));
                      setIsRepliedTo(true);
                      setButtonsShown(false);
                      showSuccessMessage('Your response has been sent');
                    } catch (error) {
                      const message =
                        error?.response?.data?.errors?.[0] ??
                        error?.message ??
                        'Unable to update approval';
                      showErrorMessage('AlertDetail - 3: ' + message);
                    } finally {
                      setResponding(false);
                    }
                  }}
                  style={[styles.button, styles.redButton]}>
                  <Ionicons
                    name="close"
                    size={16}
                    style={styles.icon}
                    color={color}
                  />
                  <Text style={styles.buttonText}>
                    {notification.button2.text}
                  </Text>
                </TouchableOpacity>
              )}
              {notification.button3 &&
                (notification.phoneNumber !== '' ||
                  notification.phoneNumber !== null) &&
                notification.button3.text === 'Call' &&
                buttonsShown &&
                !responding && (
                  <TouchableOpacity
                    onPress={() =>
                      Linking.openURL(`tel:${notification.phoneNumber}`)
                    }
                    style={[styles.button, styles.blueButton]}>
                    <Ionicons
                      name="call-outline"
                      size={16}
                      color={color}
                      style={styles.icon}
                    />
                    <Text style={styles.buttonText}>
                      {notification.button3.text}
                    </Text>
                  </TouchableOpacity>
                )}
              {responding && (
                <View
                  pointerEvents="none"
                  style={styles.respondingOverlay}>
                  <LoadingSpinner size="small" color="gray" />
                </View>
              )}
            </View>
          </Card>
        )}
      </>
    );
  };

  return (
    <Container>
      <Navbar navigation={navigation} title="Notification details" />
      {isLoading || isReading ? (
        <LoadingSpinner />
      ) : (
        <ScrollView contentContainerStyle={{flex: 1, marginBottom: 56}}>
          {!isRepliedTo && buttonsShown && !alertTimedOut && <Buttons />}
          {alertTimedOut && (
            <View style={notificationItemStyles.timedOutContainer}>
              <Text>Timed Out</Text>
            </View>
          )}
          {isRepliedTo && !alertTimedOut && (
            <View style={notificationItemStyles.responseContainer}>
              <ResponseBadge action={notification.action} />
            </View>
          )}
          {notification?.appMessageHTML ? renderHtmlContent() : <Main />}
        </ScrollView>
      )}
    </Container>
  );
};

const notificationItemStyles = StyleSheet.create({
  timedOutContainer: {
    backgroundColor: '#eab308',
    marginBottom: 4,
    borderRadius: 16,
    textAlign: 'center',
    marginLeft: 16,
    paddingLeft: 4,
    paddingRight: 4,
    margin: 8,
    width: 76,
    alignSelf: 'flex-end',
  },
  responseContainer: {
    maxWidth: 130,
    margin: 8,
    alignSelf: 'flex-end'
  }
});

const styles = StyleSheet.create({
  card: {
    padding: 8,
    marginVertical: 16,
  },
  row: {
    flexDirection: 'row',
    marginVertical: 12,
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
  },
  textLabel: {
    fontWeight: 'bold',
  },
  detailsText: {
    marginLeft: 8,
  },
  alertResponseDanger: {
    color: 'red',
  },
  alertResponseSuccess: {
    color: 'green',
  },
  mr0: {
    marginRight: 0,
  },
  button: {
    marginBottom: 8,
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 8,
    borderRadius: 4,
  },
  greenButton: {
    backgroundColor: 'green',
  },
  redButton: {
    backgroundColor: 'red',
  },
  blueButton: {
    backgroundColor: 'blue',
  },
  buttonText: {
    color: 'white',
    textAlign: 'center',
    marginRight: 8,
  },
  icon: {
    marginRight: 8,
  },
  respondingOverlay: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
  detailsImage: {
    width: 110,
    height: 88,
  },
});

export default NotificationDetails;
